import React, { useEffect, useRef, useState } from "react";
import "./../login/Login.scss";
import Image from "../../components/image/Image";
import { AppIcons } from "../../data/appIcons";
import Label from "../../components/ui/label/Label";
import Input from "../../components/ui/inputs/input/Input";
import Iconify from "../../components/ui/iconify/Iconify";
import Buttons from "../../components/ui/button/Buttons";
import { useNavigate } from "react-router-dom";
import UnderConstruction from "../../components/ui/underConstruction/UnderConstruction";
import SwalAlert from "../../services/swalService/SwalService";
import ToastService from "../../services/toastService/ToastService";
import { removeCookie } from "../../utils/Cookies/CookieHandler";
import forgotPasswordField from "./forgotPassword.formfield.config";
import FormCreator from "../../components/forms/FormCreator";
import { useForgotPasswordMutation } from "../../app/services/authAPI";

const ForgotPassword = () => {
  const navigate = useNavigate();
  const { error } = SwalAlert();

  const forgotPasswordRef = useRef();
  const [passwordForm] = useState(forgotPasswordField);

  const [sendEmail, {
    isLoading: isSendingEmail,
    isSuccess: isEmailSent,
    data: forgotResponseData
  }] = useForgotPasswordMutation();

  const handleClick = () => {
    let forgotPasswordData = forgotPasswordRef.current.getFormData();
    if (forgotPasswordData) {
      const req = {
        EmailAddress: forgotPasswordData.psEmailAddress
      }
      sendEmail(req);
    }
  };

  useEffect(() => {
    if (isEmailSent && forgotResponseData) {
      if (forgotResponseData?.errorMessage.includes('does not')) {
        error(forgotResponseData.errorMessage, "Error!")
      }
      else {
        let formData = forgotPasswordRef.current.getFormData();

        let email = formData.psEmailAddress

        ToastService.success(forgotResponseData.errorMessage);
        removeCookie('rememberMe');
        navigate(`/login`, { state: email });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isEmailSent, forgotResponseData]);

  return (
    <div className="login-page">
      <div className="logo-sec">
        <Image imagePath={AppIcons.BBCustomLogo} altText="Login Vector" />
      </div>

      <div className="login-form">
        <div className="form">
          <div className="center-icon">
            <Image imagePath={AppIcons.ForgotLogo} altText="Login Vector" />
          </div>
          <div className="title-sec">
            <h1 className="title">Forgot Password</h1>
            <p className="welcome-txt">
              Forgot your password to access your account.
            </p>
          </div>
          <form className="reset-form-section">
            <FormCreator
              ref={forgotPasswordRef}
              config={passwordForm}
            ></FormCreator>
          </form>
          <div className="btn-sec mb-1">
            <Buttons
              buttonText={"Send Email"}
              buttonTypeClassName="login-btn"
              onClick={handleClick}
              isLoading={isSendingEmail}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
